<template>
    <div>
        <a @click.prevent="showEssayAdminModal">
            <div class="course-icon-wrap hover-image-effect">
                <img height="30" src="/images/marLMS-essay-grey.png" loading="lazy" alt="" class="inactive-icon" style="opacity: 1;">
                <img height="30" src="/images/marLMS-essay-orange.png" loading="lazy" alt="" class="active-icon" style="opacity: 0;">
            </div>
        </a>
        <portal to="bodyModalContainer" v-if="shown">
            <div class="modal fade" ref="userEssayAdminModal" tabindex="-1" role="dialog" aria-hidden="true"
                 style="visibility: hidden">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document" style="visibility: visible">
                    <div class="modal-content min-keep-size resize">
                        <div class="modal-header flex mb-2">
                            <div class="modal-title" id="userQuizModalLabel">
                                <label class="font-weight-bold">{{trans('course.creator.course')}}: <span class="answer-score-bold">{{ quiz.course.name }} {{ quiz.student_course && quiz.student_course.training ? '(' + quiz.student_course.training.title + ')' : ''}}</span></label>
                                <div>
                                    <label class="font-weight-bold mb-0">{{trans('course.creator.sections.Essay')}}: <span class="answer-score-bold">{{quiz.quiz.name}}</span></label>
                                </div>
                            </div>
                            <button type="button" class="close no-drag" @click.prevent="hideEssayAdminModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12" v-if="quiz.quiz.show_description && quiz.quiz.content && quiz.quiz.content != ''">
                                    <label class="font-weight-bold">{{ trans('course.add_course_essay_description') }}</label>
                                    <course-blocks  :token="token" :content="JSON.parse(quiz.quiz.content)"></course-blocks>
                                </div>
                            </div>
                            <div class="row" style="width: 100%">
                                <div class="col-12">
                                    <label class="font-weight-bold">{{ trans('essays.student_response') }}</label>
                                    <ckeditor required v-model="form.userResponse" class="editor-border" :editor="editor" :config="textEditorConfig"></ckeditor>
                                </div>
                            </div>
                            <div class="row" style="width: 100%">
                                <div class="col-12 mt-4">
                                    <label class="font-weight-bold">{{ trans('essays.reply')}}</label>
                                    <ckeditor required v-model="form.teacherResponse" class="editor-border" :editor="editor" :config="textEditorConfig"></ckeditor>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 form-inline mt-4">
                                    <label class="d-inline-block form-inline mr-3">
                                        {{quiz.quiz.min_score_type == 'points' ? ' ' + trans('essays.points') : ' ' + trans('essays.percentage') }}
                                    </label>
                                    <input step=".01" required type="number" v-model="form.teacherPoints" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click.prevent="hideEssayAdminModal">
                                Close
                            </button>
                            <div class="col-6 ml-auto">
                                <button @click.prevent="save" class="btn btn-primary float-right" type="submit">{{ trans('forms.save')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </portal>
    </div>
</template>
<script>
    import CustomEditor from "../../includes/ck-editor/ck-editor-custom";
    export default {
        name: "essay-admin",
        components: {
        },
        props: {
            quiz: Object,
            token: String,
        },
        watch: {
        },
        data: function() {
            return {
                form:{
                    id: this.quiz.id,
                    userResponse: this.quiz.responses ? JSON.parse(this.quiz.responses)[0] : '',
                    teacherResponse: this.quiz.teacher_response ? this.quiz.teacher_response : '',
                    teacherPoints: (this.quiz.teacher_points * 1).toFixed(2).replace(/[.,]00$/, ""),
                    quizPoints: this.quiz.quiz.min_score
                },
                editor: CustomEditor,
                editorConfig: {
                    language: document.documentElement.lang,
                    startupFocus: true,
                    removePlugins: ['imageUpload','mediaEmbed'],
                    link: {
                        addTargetToExternalLinks: true,
                        defaultProtocol: 'http://',
                    },
                    toolbar: {
                        removeItems: ['uploadImage', 'mediaEmbed']
                    },
                },
                textEditorConfig: {
                    language: document.documentElement.lang,
                    removePlugins: ['imageUpload','mediaEmbed'],
                    link: {
                        addTargetToExternalLinks: true,
                        defaultProtocol: 'http://',
                    },
                    toolbar: {
                        removeItems: ['uploadImage', 'mediaEmbed']
                    },
                },
                shown: false,
            }
        },
        methods: {
            save: function() {
                let $end = '/api/save-essay';
                axios.post($end, this.form).then(response  => {
                    this.hideEssayAdminModal();
                    window.location.reload();
                }).catch(err => {
                    this.$data.loader = false;
                });
            },
            showEssayAdminModal() {
                this.shown = true;
                this.$nextTick(() => {
                    $(this.$refs.userEssayAdminModal).modal('show');
                })
            },
            hideEssayAdminModal() {
                $(this.$refs.userEssayAdminModal).modal('hide');
                this.shown = false;
            },
        },
    }
</script>
